webpackJsonp([141384726791721],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Gallery = __webpack_require__(14);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _SEO = __webpack_require__(9);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SubMenu = __webpack_require__(15);
	
	var _SubMenu2 = _interopRequireDefault(_SubMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var editorialPage = function editorialPage(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SubMenu2.default, { thisName: 'Editorial' }),
	    _react2.default.createElement(
	      'div',
	      { style: transition && transition.style },
	      _react2.default.createElement(_SEO2.default, { slug: 'editorial' }),
	      _react2.default.createElement(_Gallery2.default, { sizes: data.editorial.edges })
	    )
	  );
	};
	
	exports.default = editorialPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-editorial-index-js-e2882b962419975ac681.js